import { ReactComponent as Practice } from "../assets/sidebar/user.svg";
import { ReactComponent as User } from "../assets/sidebar/user.svg";
import { ReactComponent as Exercise } from "../assets/sidebar/exercise.svg";
import { ReactComponent as Condition } from "../assets/sidebar/user.svg";
import { ReactComponent as Treatment } from "../assets/sidebar/treatment.svg";
import { ReactComponent as Phase } from "../assets/sidebar/phase.svg";
import { ReactComponent as Video } from "../assets/sidebar/video.svg";
import { ReactComponent as Protocol } from "../assets/sidebar/user.svg";
import { ReactComponent as Citation } from "../assets/sidebar/treatment.svg";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

export const menuItems = [
  { id: "dashboard", text: "Dashboard", route: "/" },
  {
    id: "practices",
    text: "Practices",
    icon: <Practice />,
    route: "/practices",
  },
  { id: "users", text: "Users", icon: <User />, route: "/users" },
  {
    id: "exercises",
    text: "Exercises",
    icon: <Exercise />,
    route: "/exercises",
  },
  {
    id: "conditions",
    text: "Conditions",
    icon: <Condition />,
    route: "/conditions",
  },
  {
    id: "treatments",
    text: "Treatments",
    icon: <Treatment />,
    route: "/treatments",
  },
  { id: "phases", text: "Phases", icon: <Phase />, route: "/phases" },
  { id: "videos", text: "Videos", icon: <Video />, route: "/videos" },
  {
    id: "protocols",
    text: "Protocols",
    icon: <Protocol />,
    route: "/protocols",
  },
  {
    id: "citations",
    text: "Citations",
    icon: <Citation />,
    route: "/citations",
  },
  {
    id: "referrals",
    text: "Referrals",
    icon: <CardGiftcardIcon />,
    route: "/referrals",
  },
];
